import React, { useEffect, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Dialog from '@material-ui/core/Dialog';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import FormHelperText from '@material-ui/core/FormHelperText';
import { useForm } from 'react-hook-form';

import UpdateConfirmDialog from './UpdateConfirmDialog';
import DialogTitle from '@material-ui/core/DialogTitle';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

/**
 * Function to modificate the pricing plans
 * @param {*} props
 * @returns
 */
function UpdatePeriodDialog(props) {
  const {
    openStatus, onClosed, rowData, schoolYear
  } = props;
  /**
  * Status confirm screen
  */
  const [statusConfirm, setStatusConfirm] = React.useState(false);
  const [modifiedData, setModifiedData] = React.useState({});
  const [schoolYearId, setSchoolYearId] = useState("");
  const [helperTextType, setHelperTextType] = React.useState();
  const [errorType, setErrorType] = React.useState(false);
  /**
  * Status helper text
  */
  const [helpertext, setHelperText] = React.useState();
  const [error, setError] = React.useState(false);
  const { register, handleSubmit, errors } = useForm();

  const handleCloseConfirm = () => {
    setStatusConfirm(false);
  };

  /**
   * Method to add the register and create que request
   * @param {*} formData
   */
  const onSubmit = async(formData) => {
    if (schoolYearId === "") {
      // validate the required field role type
        setHelperTextType("Valor requerido");
        setErrorType(true);
    } else { 
      const requestBody = {
          id:rowData[0],
          name: formData.name,
          initial_date: formData.initial_date,
          final_date: formData.final_date,
          school_year_id: schoolYearId.id,
          status: rowData[5]
        };
        setModifiedData(requestBody);
        setHelperText('');
        setError(false);
        onClosed();
        setStatusConfirm(true);
      };
    }

  /**
   * Method to recover the period type list and atribute list
   * @param {data} data
   */
  useEffect(() => {
    schoolYear.map((option) => {
      if (option.id === rowData[5]) {
        setSchoolYearId(option);
      }
    });
  }, [openStatus]);

  /**
   * Method to close the dialog
   */
  const handleCloseAction = () => {
    setHelperText('');
    setError(false);
    onClosed();
  };

   /**
 * Method to control the combobox of role type
 */
   const handleChangeSchoolYear = (event) => {
    setSchoolYearId(event.target.value);
  };


  return (
    <div>
    <Grid container justifyContent="center" direction="column">
      <Dialog
        fullWidth
        maxWidth="sm"
        open={openStatus}
        onClose={handleCloseAction}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Añadir</DialogTitle>
        <DialogContent>
          <form noValidate onSubmit={handleSubmit(onSubmit)} id = "modifyForm">
            <div >
                <TextField
                required
                name="name"
                autoFocus
                margin="dense"
                id="name"
                defaultValue={rowData[1]}
                inputRef={register({
                  required: "El campo es requerido",
                })}
                error={!!errors.name} helperText={errors.name ? errors.name.message : ''}
                label="Nombre"
                type="text"
                width="90%"
              />

              <TextField
                required
                name="initial_date"
                autoFocus
                margin="dense"
                id="initial_date"
                inputRef={register({
                  required: "El campo es requerido",
                })}
                error={!!errors.initial_date} helperText={errors.initial_date ? errors.initial_date.message : ''}
                label="Fecha de inicio"
                type="date"
                fullWidth
                defaultValue={rowData[2]}
              />
              <TextField
                required
                name="final_date"
                autoFocus
                margin="dense"
                id="final_date"
                inputRef={register({
                  required: "El campo es requerido",
                })}
                error={!!errors.final_date} helperText={errors.final_date ? errors.final_date.message : ''}
                label="Fecha fin"
                type="date"
                fullWidth
                defaultValue={rowData[3]}
              />

              <br/>
                <FormControl width="90%" >
                  <InputLabel required error={errorType} htmlFor="status-helper">Padre de Familia:</InputLabel>
                  <Select
                    name="schoolYear"
                    labelId="demo-checkbox-label"
                    id="schoolYear"
                    fullWidth
                    value={schoolYearId}
                    onChange={handleChangeSchoolYear}
                    input={<Input />}
                    MenuProps={MenuProps}
                    style={{width:"200px"}}
                  >
                    <MenuItem name="" value="">
                      Ninguno
                    </MenuItem>
                    {schoolYear.map((value, key) => (
                      <MenuItem name={value} key={key.toString()} value={value}>
                         {value.year }
                      </MenuItem>
                    ))}
                  </Select>
                  {errorType && <FormHelperText error>{helperTextType}</FormHelperText>}
                </FormControl>
                <br/>
              
            </div>
          </form>
        </DialogContent>
        <DialogActions>
          <Button id="button_close" onClick={handleCloseAction}>Cerrar</Button>
          <Button id="button_agree_modify_period" variant="contained" style={{backgroundColor: "#68dcb9", color: "#FFFFFF"}} type="submit" form="modifyForm">
            Modificar
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
     <UpdateConfirmDialog openStatusConfirm={statusConfirm} onClosedConfirm={handleCloseConfirm} rowData={modifiedData}/>
     </div>
  );
}

UpdatePeriodDialog.propTypes = {
  /** Status of modify dialog */
  openStatus: PropTypes.bool.isRequired,
  /** Function of modify dialog */
  onClosed: PropTypes.func.isRequired,
  /** Array of pricing plan */
  rowData: PropTypes.array.isRequired

};

export default UpdatePeriodDialog;
